import { render, staticRenderFns } from "./ForcedRegistrations.vue?vue&type=template&id=355806f2&scoped=true&"
import script from "./ForcedRegistrations.vue?vue&type=script&lang=js&"
export * from "./ForcedRegistrations.vue?vue&type=script&lang=js&"
import style0 from "./ForcedRegistrations.vue?vue&type=style&index=0&id=355806f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355806f2",
  null
  
)

export default component.exports